import { EnvironmentGroupId } from '@/react/portainer/environments/types';
import { capitalize } from '@/react/common/string-utils';

import { Option } from '@@/form-components/PortainerSelect';

export const POD_SECURITY_PROFILES = [
  'privileged',
  'baseline',
  'restricted',
] as const;
export type PodSecurityProfile = (typeof POD_SECURITY_PROFILES)[number];

export const POD_SECURITY_MODES = ['enforce', 'audit', 'warn'] as const;
export type PodSecurityMode = (typeof POD_SECURITY_MODES)[number];

/**
 * Namespaces the server forces onto the privileged profile (system namespaces and the
 * Portainer-managed namespaces). Mirrors the backend Validate() rules in
 * package/server-ee/api/policies/pod_security_standards_k8s.go so the UI rejects the same
 * inputs before submission.
 */
export const PRIVILEGED_REQUIRED_NAMESPACES = [
  'kube-system',
  'kube-public',
  'kube-node-lease',
  'portainer',
  'portainer-agent',
] as const;

export const PROFILE_OPTIONS: ReadonlyArray<Option<PodSecurityProfile>> =
  POD_SECURITY_PROFILES.map((profile) => ({ label: profile, value: profile }));

export const POD_SECURITY_MODE_FIELDS: ReadonlyArray<{
  mode: PodSecurityMode;
  label: string;
}> = POD_SECURITY_MODES.map((mode) => ({ mode, label: capitalize(mode) }));

export interface PodSecurityNamespaceEntry {
  namespace: string;
  enforce?: PodSecurityProfile;
  audit?: PodSecurityProfile;
  warn?: PodSecurityProfile;
}

export interface PodSecurityStandardsFormValues {
  name: string;
  environmentGroupIds: Array<EnvironmentGroupId>;
  namespaces: Array<PodSecurityNamespaceEntry>;
}

/**
 * API payload shape sent as the policy `Data` field. Matches the Go
 * PodSecurityStandardsPolicyData struct.
 */
export interface PodSecurityStandardsPolicyPayload {
  namespaces: Array<PodSecurityNamespaceEntry>;
}

export function buildNamespaceEntry(): PodSecurityNamespaceEntry {
  return { namespace: '' };
}

export const POD_SECURITY_STANDARDS_INITIAL_VALUES: PodSecurityStandardsFormValues =
  {
    name: '',
    environmentGroupIds: [],
    namespaces: [],
  };
